/* KK32 Halloween page (Figma KK-32, 2026-10-15).
   Moves the "🎃 HALLOWEEN ✦ BUY 1 GET 1 FREE 👻" bar from the buy box to the
   top of the page (above the header group). Animations are CSS only
   (kk32-offer.css). */
(function () {
  'use strict';

  function placeBanner() {
    var banner = document.querySelector('[data-kk32-banner]');
    if (!banner) return;
    var header = document.getElementById('shopify-section-group-header-group')
      || document.querySelector('.shopify-section-group-header-group');
    var target = header || document.getElementById('MainContent');
    if (target && target.parentNode && banner.nextElementSibling !== target) {
      target.parentNode.insertBefore(banner, target);
    }
    banner.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBanner);
  } else {
    placeBanner();
  }
  // Theme editor re-renders the section; re-place the (new) banner.
  document.addEventListener('shopify:section:load', placeBanner);
})();
